module.exports = __webpack_public_path__ + "static/media/Leisure_centre_belfast.b7baeb69.jpg";